;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { NOTIFICATION_CATEGORIES, NOTIFICATION_SUBCATEGORIES } from '../lib/constants';

export type NotificationCategory =
  (typeof NOTIFICATION_CATEGORIES)[keyof typeof NOTIFICATION_CATEGORIES];

export type NotificationSubcategory =
  (typeof NOTIFICATION_SUBCATEGORIES)[keyof typeof NOTIFICATION_SUBCATEGORIES];

export interface MenuItemSub {
  title: string;
  url: string;
  icon?: React.ReactNode;
  /** Client-only matcher for paths where url-based matching is insufficient (e.g. currency wallet routes). */
  isPathActive?: (pathname: string) => boolean;
  /** When true, item is visible with muted styling and shows tooltip on hover (no navigation). */
  inactive?: boolean;
  /** Shown in tooltip when inactive; explains why the page is not active. */
  tooltip?: string;
  /** Notification category key for this subitem; badge is derived from notification counts for this category. */
  category?: NotificationCategory;
  /** Notification subcategory key (e.g. payroll monthly_inputs); badge uses subcategory counts when set. */
  subcategory?: NotificationSubcategory;
  /** Optional count badge (e.g. unread notifications). Set from category/subcategory when using notificationCounts. */
  badge?: number;
}

export type MenuItem = {
  title: string;
  url?: string;
  iconName?: string;
  icon?: React.ReactNode;
  component?: React.ReactNode;
  mobileComponent?: React.ReactNode;
  bottom?: boolean;
  bottomSeparated?: boolean;
  /** When true, navbar renders extra space above this item (mobile only). */
  spaceAbove?: boolean;
  urlPrefix?: string; // We need this to handle the cases where we have multiple subpages under the same menu item
  excludeUrlPrefix?: string | string[]; // Exclude paths starting with this prefix from being active (used with urlPrefix)
  /** Sub items rendered with SidebarMenuSub (e.g. under Monthly inputs: Payroll, PaaS management). */
  items?: MenuItemSub[];
  onClick?: () => void;
  disabled?: boolean;
  /** Notification category key for this item; badge is derived from notification counts. Parent with category uses API category count; otherwise sum of children. */
  category?: NotificationCategory;
  /** Notification subcategory key for leaf items (e.g. monthly inputs only nav). */
  subcategory?: NotificationSubcategory;
  /** Optional count badge shown next to the item. Set from notificationCounts. */
  badge?: number;
  /** When true, the link opens in a new browser tab. */
  openInNewTab?: boolean;
  /** Identifies mobile menu items that open a full menu subview. */
  subviewKey?: 'notifications' | 'organisationSwitcher';
};
